// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "_assets/" + chunkId + "-" + "b66e1652c74446da98c6" + "-ade4ba9718be3d0b2f6b26782fbeda8b1ed36057.css";
};